import { Stack } from "@mui/material";
import { KbFileSection, KbFolderSection } from "./KbSection";
import { useGetKbStarredRecords } from "controller";
import { generateKbFilesAndFolders } from "../helpers";
import { KbNoDataScreen } from "./KbNoDataScreen";

export const KbStarred = () => {
  const { data: starredRecords, isLoading } = useGetKbStarredRecords({});

  const { files, folders } = generateKbFilesAndFolders(starredRecords);

  return (
    <Stack>
      {!isLoading && files?.length === 0 && folders?.length === 0 ? (
        <KbNoDataScreen showCreateButton={false} />
      ) : (
        <Stack>
          {folders?.length !== 0 && <KbFolderSection folders={folders || []} />}
          {files?.length !== 0 && (
            <KbFileSection isSelectable={false} files={files || []} />
          )}
        </Stack>
      )}
    </Stack>
  );
};
